(() => {
  const form = document.querySelector('[data-collection-filters]');
  if (!form) return;
  const current = new URL(window.location.href);
  const missing = [];
  const inputs = [...form.querySelectorAll('input[name]')];
  const selections = [];
  const seen = new Set();
  for (const [name, raw] of current.searchParams) {
    if (!name.startsWith('filter.') || name.startsWith('filter.v.price.')) continue;
    for (const value of raw.split(',')) {
      const identity = JSON.stringify([name, value]);
      if (!value || seen.has(identity)) continue;
      seen.add(identity); selections.push({ name, value });
    }
  }
  for (const { name, value } of selections) {
    const represented = inputs.some(input => input.name === name && input.value === value && (input.checked || input.type === 'hidden'));
    if (represented) continue;
    const hidden = document.createElement('input');
    hidden.type = 'hidden'; hidden.name = name; hidden.value = value;
    hidden.dataset.restoredFilter = 'true';
    form.append(hidden);
    missing.push({ name, value, hidden });
  }
  if (!missing.length) return;
  let chips = document.querySelector('.apaw-active-filters');
  if (!chips) { chips = document.createElement('div'); chips.className = 'apaw-active-filters'; form.after(chips); }
  const sort = form.querySelector('[name="sort_by"]')?.value;
  const removalUrl = (name, value) => {
    const url = new URL(current);
    const remaining = [...new Set(url.searchParams.getAll(name).flatMap(item => item.split(',')))].filter(item => item !== value);
    url.searchParams.delete(name);
    remaining.forEach(item => url.searchParams.append(name, item));
    url.searchParams.delete('page');
    if (sort) url.searchParams.set('sort_by', sort);
    return url.pathname + url.search;
  };
  for (const item of missing) {
    const chip = document.createElement('a');
    chip.href = removalUrl(item.name, item.value);
    const label = document.createElement('span');
    label.textContent = item.value.startsWith('gid://') ? 'Selected filter' : item.value;
    const close = document.createElement('span'); close.setAttribute('aria-hidden', 'true'); close.textContent = ' ×';
    chip.append(label, close); chips.prepend(chip); item.label = label;
  }
  if (!chips.querySelector('.apaw-active-filters__clear')) {
    const clear = document.createElement('a'); clear.className = 'apaw-active-filters__clear'; clear.textContent = 'Clear all';
    const url = new URL(form.action); if (sort) url.searchParams.set('sort_by', sort);
    clear.href = url.pathname + url.search; chips.append(clear);
  }
  const source = new URL(form.action);
  if (sort) source.searchParams.set('sort_by', sort);
  if (current.searchParams.has('preview_theme_id')) source.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
  fetch(source, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
    .then(response => { if (!response.ok) throw new Error('Filter choices unavailable'); return response.text(); })
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nativeInputs = [...doc.querySelectorAll('[data-collection-filters] input[type="checkbox"]')];
      const panel = form.querySelector('[data-filter-panel]');
      const restored = new Map();
      for (const item of missing) {
        const native = nativeInputs.find(input => input.name === item.name && input.value === item.value);
        const option = native?.closest('label');
        const title = option?.querySelector('span')?.textContent?.trim();
        if (title) item.label.textContent = title;
        if (!native || !panel) continue;
        if (form.dataset.filterCollection === 'candles' && item.name === 'filter.p.m.custom.tea_focus') continue;
        let group = [...panel.querySelectorAll('[data-filter-param]')].find(element => element.dataset.filterParam === item.name) || restored.get(item.name);
        if (!group) {
          group = native.closest('.apaw-filter-group').cloneNode(true);
          group.querySelector('.apaw-filter-group__body').replaceChildren();
          group.querySelector('.apaw-filter-count')?.remove();
          group.open = true; restored.set(item.name, group);
          panel.insertBefore(group, panel.querySelector('.apaw-filters__actions'));
        }
        panel.hidden = false;
        const toggle = form.querySelector('.apaw-filter-toggle'); if (toggle) toggle.hidden = false;
        const clonedOption = option.cloneNode(true);
        const control = clonedOption.querySelector('input'); control.checked = true; control.disabled = false;
        for (const existing of group.querySelectorAll('input')) {
          if (existing.name === item.name && existing.value === item.value) existing.closest('label')?.remove();
        }
        const count = clonedOption.querySelector('small'); if (count) count.textContent = '0';
        group.querySelector('.apaw-filter-group__body').append(clonedOption);
        item.hidden.remove();
      }
    }).catch(() => {});
})();
